// import React, { useRef, useEffect, useState } from "react";
// import { Card } from "react-bootstrap";
// import "../css/main.css";

// const ExpertDescriptionEdit = ({ video, videoRef }) => {
//   const descriptionRef = useRef(null);
//   const [editingIndex, setEditingIndex] = useState(null);
//   const [editedText, setEditedText] = useState("");

//   const tsToSeconds = (ts) => {
//     const parts = ts.split(":");
//     if (parts.length === 3) {
//       return (+parts[0]) * 3600 + (+parts[1]) * 60 + (+parts[2]);
//     }
//     if (parts.length === 2) {
//       return (+parts[0]) * 60 + (+parts[1]);
//     }
//     return Number(ts);
//   };

//   const jumpTo = (ts) => {
//     if (!videoRef.current) return;
//     videoRef.current.currentTime = tsToSeconds(ts);
//     videoRef.current.play();
//   };

//   const startInlineEdit = (item) => {
//     setEditingIndex(item.index);
//     setEditedText(item.caption);
//   };

//   const saveInlineEdit = async (item) => {
//     await fetch("/api/update-description", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         index: item.index,
//         caption: editedText,
//         video_id: video.id,
//       }),
//     });

//     setEditingIndex(null);
//     window.location.reload();
//   };

//   const deleteDescription = async (item) => {
//     if (!window.confirm("Delete this description?")) return;
//     await fetch(`/api/delete-description/${item.index}`, {
//       method: "DELETE",
//     });
//     window.location.reload();
//   };

//   const buildFinalTimeline = (descriptions = []) => {
//     let offset = 0;
//     return descriptions.map((d, index) => {
//       const start = d.end + offset;
//       offset += d.duration ?? 0;
//       return { index, audio_start: start, caption: d.caption };
//     });
//   };

//   return (
//     <Card className="video-card shadow-sm">
//       <h6 className="fw-bold mb-2">Descriptions</h6>

//       <div ref={descriptionRef} className="description-box">
//         {buildFinalTimeline(video.descriptions)
//           .filter((d) => d.caption?.trim())
//           .map((item) => {
//             const ts = new Date(item.audio_start * 1000)
//               .toISOString()
//               .substring(11, 23);

//             return (
//               <div key={item.index} className="desc-item">
//                 <div
//                   className="desc-main"
//                   onClick={() => jumpTo(ts)}
//                 >
//                   <span className="desc-time">{ts}</span>

//                   {editingIndex === item.index ? (
//                     <input
//                       className="inline-edit-input"
//                       autoFocus
//                       value={editedText}
//                       onChange={(e) => setEditedText(e.target.value)}
//                       onKeyDown={(e) => {
//                         e.stopPropagation();
//                         if (e.key === "Enter") saveInlineEdit(item);
//                         if (e.key === "Escape") setEditingIndex(null);
//                       }}
//                       onBlur={() => saveInlineEdit(item)}
//                     />
//                   ) : (
//                     <span
//                       className="desc-text"
//                       onDoubleClick={() => startInlineEdit(item)}
//                     >
//                       {item.caption}
//                     </span>
//                   )}
//                 </div>

//                 <div className="desc-actions">
//                   <button
//                     className="icon-btn edit"
//                     onClick={() => startInlineEdit(item)}
//                   >
//                     ✏️
//                   </button>
//                   <button
//                     className="icon-btn delete"
//                     onClick={() => deleteDescription(item)}
//                   >
//                     🗑️
//                   </button>
//                 </div>
//               </div>
//             );
//           })}
//       </div>
//     </Card>
//   );
// };

// export default ExpertDescriptionEdit;


import React, { useRef, useEffect, useState } from "react";

const ExpertDescriptionEdit = ({ video, videoRef }) => {
  const descriptionRef = useRef(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedText, setEditedText] = useState("");

  if (!video || !video.descriptions) {
    return <div className="p-2 text-muted">No descriptions</div>;
  }

  const buildFinalTimeline = (descriptions = []) => {
    let offset = 0;
    return descriptions.map((d, index) => {
      const start = d.end + offset;
      offset += d.duration ?? 0;
      return {
        index,
        audio_start: start,
        caption: d.caption
      };
    });
  };

  const tsToHHMMSS = (s) =>
    new Date(s * 1000).toISOString().substring(11, 23);

  const jumpTo = (sec) => {
    if (!videoRef?.current) return;
    videoRef.current.currentTime = sec;
    videoRef.current.play();
  };

  return (
    <div className="right-description-panel" ref={descriptionRef}>
      {buildFinalTimeline(video.descriptions)
        .filter(d => d.caption?.trim())
        .map((item) => {
          const ts = tsToHHMMSS(item.audio_start);

          return (
            <div key={item.index} className="desc-item">
              <span className="desc-time" onClick={() => jumpTo(item.audio_start)}>
                {ts}
              </span>

              {editingIndex === item.index ? (
                <input
                  className="inline-edit-input"
                  autoFocus
                  value={editedText}
                  onChange={(e) => setEditedText(e.target.value)}
                  onBlur={() => setEditingIndex(null)}
                />
              ) : (
                <span
                  className="desc-text"
                  onDoubleClick={() => {
                    setEditingIndex(item.index);
                    setEditedText(item.caption);
                  }}
                >
                  {item.caption}
                </span>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default ExpertDescriptionEdit;
